import { render, staticRenderFns } from "./logwood-package-id.vue?vue&type=template&id=1bb7fcd0&scoped=true&"
import script from "./logwood-package-id.vue?vue&type=script&lang=ts&"
export * from "./logwood-package-id.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb7fcd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb7fcd0')) {
      api.createRecord('1bb7fcd0', component.options)
    } else {
      api.reload('1bb7fcd0', component.options)
    }
    module.hot.accept("./logwood-package-id.vue?vue&type=template&id=1bb7fcd0&scoped=true&", function () {
      api.rerender('1bb7fcd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-package-id.vue"
export default component.exports